import { FetchPolicy, useLazyQuery } from '@apollo/client'

import { GetOrganisationDocument } from '@/graphql/purchase-plus/generated/getOrganisation.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import useOrganisationId from '@/modules/shared/hooks/params/useOrganisationId'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetLazyOrganisationProps {
  organisationId?: number
  fetchPolicy?: FetchPolicy
}

export default function useGetLazyOrganisation(args?: UseGetLazyOrganisationProps) {
  const { organisationId: organisationIdProp, fetchPolicy } = args || {}
  const organisationId = useOrganisationId()
  const [fetchOrganisation, { networkStatus, data, error, refetch }] = useLazyQuery(GetOrganisationDocument, {
    variables: {
      organisationId: Number(organisationIdProp || organisationId),
    },
    notifyOnNetworkStatusChange: true,
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    fetchPolicy,
  })

  return {
    fetchOrganisation,
    organisation: data?.organisation,
    loadingStates: checkNetworkStatus(networkStatus),
    error,
    refetch,
  }
}
